<template>
  <div class="upload-page">
      <div class="wrapper">
          <div class="content" @click="uploadClick()">
            <icon :icon="'upload'" />
            <h2 v-if="form1 !== null && form1.value === ''">{{ title }}</h2>
            <h2 v-if="form1 !== null && form1.value !== ''">{{ title2 }}</h2>
            <h4>or drag and drop a file here</h4>
            <br/>
            <br/>
            <p>JPG, PNG and TIFF files are supported</p>
            <input type="file" name="file"   id="file"   ref="payload" /><br/>
          </div>
          <div class="row">
            <h3 style="text-align: left; border-bottom: 1px solid #ddd;margin: 15px 0 25px 0;">Item info</h3>
            <div class="col">
              <label style="margin-right: 10px;">GTIN</label><input type="text" name="gtin"   id="gtin"   ref="gtin"     /><br/><br/>
            </div>
            <div class="col">
              <label style="margin-right: 10px;">IP GLN</label><input type="text" name="gln"   id="gln"   ref="gln"     /><br/><br/>
            </div>
          </div>
          <div class="row">
            <h3 style="text-align: left; border-bottom: 1px solid #ddd;margin: 15px 0 25px 0;">Asset info</h3>
            <div class="col-xs-12">
              
            </div>
            <div class="col-sm-6">
              <label style="margin-right: 10px;">Type of Information</label><input type="text" name="typeOfInformation"   id="typeOfInformation"   ref="typeOfInformation"     /><br/><br/>
            </div>
            <div class="col-sm-6">
              <label style="margin-right: 10px;">Image Facing</label><input type="text" name="imageFacing"   id="imageFacing"   ref="imageFacing"     /><br/><br/>
            </div>
            <div class="col-sm-6">
              <label style="margin-right: 10px;">Uniform Resource Identifier</label><input type="text" name="uniformResourceIdentifier"   id="uniformResourceIdentifier"   ref="uniformResourceIdentifier"     /><br/><br/>
            </div>
            <div class="col-sm-6">
              <label style="margin-right: 10px;">File Effective Start Date Time</label><input type="text" name="fileEffectiveStartDateTime"   id="fileEffectiveStartDateTime"   ref="fileEffectiveStartDateTime"     /><br/><br/>
            </div>
          </div>
          <div>
            <button style="margin-top: 20px;" class="btn btn-primary btn-full" @click="upload($event)">Upload file</button>
          </div>
      </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AssetService } from "@/common/api.service";
import icon from "@/assets/icons/icons";

export default {
  name: "upload",
  computed: {
    ...mapGetters(["isAuthenticated", "tags"]),
    tag() {
      return this.$route.params.tag;
    }
  },
  methods: {
    uploadClick: function () {
      if(this.$refs.payload.value === null || this.$refs.payload.value === '') {
        this.$refs.payload.click();
      }
      
      return true;
    },
    upload: function (event) {
      const formData = new FormData();

      if(this.$refs.payload.files.length === 0) {
        alert('Image file is required')
        return;
      }

      for(var i in this.$refs.payload.files) {
        var file = this.$refs.payload.files[i];
        if(file instanceof Blob) {
          formData.append('file', file, file.name);
        }
        
      }
      formData.append('gtin', this.$refs.gtin.value);
      formData.append('gln', this.$refs.gln.value);

      // DAM
      formData.append('typeOfInformation', this.$refs.typeOfInformation.value);
      formData.append('imageFacing', this.$refs.imageFacing.value);
      formData.append('uniformResourceIdentifier', this.$refs.uniformResourceIdentifier.value);
      formData.append('fileEffectiveStartDateTime', this.$refs.fileEffectiveStartDateTime.value);

      console.log(formData);

      AssetService.upload(formData).then((data) => {
        if(data.error) {
          alert(data.payload)
        } else {
          this.$router.push({name:'dashboard'})
        }
      });
    }
  },
  data: function() {
      return {
          title: 'Browse a file to upload',
          title2: 'Click to upload a second file',
          form1: null,
          form2: null
      }
  },
  mounted: function () {
    this.form1 = this.$refs.payload;
  },
  components: {
      icon
  }
};
</script>
